import { render, staticRenderFns } from "./UsersGroupsInput.vue?vue&type=template&id=0237383a&scoped=true&"
import script from "./UsersGroupsInput.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsInput.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroupsInput.vue?vue&type=style&index=0&id=0237383a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237383a",
  null
  
)

export default component.exports